﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_registerMailConfirmedSucces from './tpl/registerMailConfirmedSucces.html';
import language from '../../../common/language';
import View_LayoutError from '../../../lib/views/layoutError/layoutError';

import * as Entities_Empty from '../../../lib/entities/empty';
import View_DialogBoxInactive from '../../../lib/views/dialogBoxInactive/dialogBoxInactive';

import paymentGateway from '../../../common/helper/paymentGateway';

export default View_LayoutError.extend({
    getTemplate: function () {
        return tpl_registerMailConfirmedSucces({ model: this.model.toJSON() });
    },
    initialize: function () {
        var self = this;
        this.app = this.options.app;
        
        switch(this.model.attributes.RegisterSuccesMessage) {
            case -1: this.model.attributes.text = String.format(resources.X200194, this.model.attributes.Name); break;
            case 0: this.model.attributes.text = String.format(resources.X200195, this.model.attributes.Name); break;
            case 1: this.model.attributes.text = String.format(resources.X200196, this.model.attributes.Name); break;
            case 2: this.model.attributes.text = String.format(resources.X200197, this.model.attributes.Name); break;
            case 3: this.model.attributes.text = String.format(resources.X200198, this.model.attributes.Name); break;
            case 4: this.model.attributes.text = String.format(resources.X200199, this.model.attributes.Name); break;

        }

        this.model.attributes.text = String.format(resources.X200213, this.model.attributes.Name);
    },
    onBeforeShow: function () {
    },
    ui: {
        'registerMailConfirmedSucces_div_paymentGateway' : '#registerMailConfirmedSucces_div_paymentGateway'
    },
    events: {
        "submit": "Inactive"
    },
    onRender: function () {
        var self = this;

        var callbackRender = function(html) {
            self.ui.registerMailConfirmedSucces_div_paymentGateway.html(html);
        }

        if ((this.model.attributes.RegisterSuccesMessage == 2) || (this.model.attributes.RegisterSuccesMessage == 3)) {
            

            //var paymentStatus = false;
            //switch (modelCustomSubscription.attributes.DineroInvoicePaymentStatus) {
            //    case 'Draft' : 
            //    case 'Draft' : paymentStatus = false; break;
            //    case 'Paid' : 
            //    case 'OverPaid' : paymentStatus = true; break;
            //    case 'Overdue' : paymentStatus = false; break;
            //}

            var callbackGetPaymentGateway = function () {
                var modelCustomSubscription = app.entities.collections.publicCustomSubscription.fullCollection.models[0];
                var modelCustomSubscriptionJob = null;
                if (app.entities.collections.publicCustomSubscriptionJob.fullCollection.length > 0) {
                    //modelCustomSubscriptionJob = app.entities.collections.publicCustomSubscriptionJob.fullCollection.models[0];
                    var modelCustomSubscriptionList = app.entities.collections.publicCustomSubscriptionJob.fullCollection.where({ SubscriptionGuid: modelCustomSubscription.attributes.SubscriptionGuid });
                    if (modelCustomSubscriptionList.length > 0) {
                        modelCustomSubscriptionJob = modelCustomSubscriptionList[0]; 
                    }
                }
                var modelConfigSubscriptionPayment = self.app.entities.collections.publicConfigSubscriptionPayment.where( {id : modelCustomSubscription.attributes.ConfigSubscriptionPaymentId});

                if (modelConfigSubscriptionPayment.length > 0) {
                    switch (modelConfigSubscriptionPayment[0].attributes.GatewayType) {
                        case 1: paymentGateway.EPay(self.model.attributes.AuthUserId, 'X200200', self.model.attributes.Name, modelCustomSubscription, modelCustomSubscriptionJob, callbackRender); break;
                        case 2: paymentGateway.Events4us(self.model.attributes.AuthUserId, 'X200200', self.model.attributes.Name, modelCustomSubscription, modelCustomSubscriptionJob, callbackRender); break;
                        
                    }
                }
            }
            //if (paymentStatus == false) {
                paymentGateway.getPaymentGateway(this.app, this.model.attributes.AuthUserId, callbackGetPaymentGateway);
            //}
        }
    },
    onAttach(){
    },
    onDestroy(){
    },
    Inactive: function () {
        var dialogBoxInactiveModel = new Entities_Empty.Model();
        dialogBoxInactiveModel.attributes.Text = resources.X200201;
        var dialogBoxInactive = new View_DialogBoxInactive({ model: dialogBoxInactiveModel, parent: self });
        this.app.dialogRegion.show(dialogBoxInactive);
    }

}, Backbone.Radio.Requests);
